// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#2F54EB","theme":"default"};